module.exports = __webpack_public_path__ + "img/sl.82ce1148.svg";